module.exports = __webpack_public_path__ + "media/images/orion_pictos/orion-iphone-e88d9ee3f92e49d664751addb8158fec.svg";